import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Compré un domingo a la noche. El lunes entré al centro con el plan exacto de la clase. Las fichas del Tomo 1 son exactamente lo que necesitaba para evaluar a mis alumnos desde el primer día. Nunca más improviso.',
  name: 'Sofía M.',
  role: 'Profesora de Educación Física en Club Social',
  loc: 'Buenos Aires',
  initial: 'S',
  color: 'bg-blue-500'
}, {
  quote: 'El Tomo 4, el de Equilibrio y Prevención de Caídas, me cambió todo. El primer mes, alumnos que llevaban meses con miedo a moverse mejoraron visiblemente su confianza y su estabilidad. El protocolo de seguridad me da la tranquilidad que antes no tenía.',
  name: 'Carolina R.',
  role: 'Profe en Centro de Día para Adultos Mayores',
  loc: 'Rosario',
  initial: 'C',
  color: 'bg-green-500'
}, {
  quote: 'El sistema de Fuerza Adaptada del Tomo 3 es único en el mercado. 10 clases listas para usar, con las progresiones descriptas paso a paso. Antes tardaba horas armando una clase. Ahora abro el PDF y en 5 minutos tengo todo listo.',
  name: 'Valentina F.',
  role: 'Kinesióloga y Entrenadora Personal',
  loc: 'Córdoba',
  initial: 'V',
  color: 'bg-purple-500'
}, {
  quote: 'La Guía de Variaciones en 3 Niveles eliminó el problema del grupo heterogéneo. Ahora muestro las 3 versiones de cada ejercicio y cada alumno hace la que le corresponde. Los más avanzados se sienten desafiados y los principiantes se sienten seguros.',
  name: 'Luciana P.',
  role: 'Profe en Geriátrico y Consultoría Particular',
  loc: 'Tucumán',
  initial: 'L',
  color: 'bg-pink-500'
}, {
  quote: 'La tasa de abandono de mis grupos bajó muchísimo. Sin cambiar lo que enseño. Solo aplicando el sistema de progresión mensual del calendario y la variedad de los 6 tomos. Los alumnos ahora quieren venir porque siempre hay algo nuevo.',
  name: 'Marcela G.',
  role: 'Profe de Educación Física Online y Presencial',
  loc: 'Mendoza',
  initial: 'M',
  color: 'bg-orange-500'
}, {
  quote: 'El Script de Primera Clase con Adulto Mayor me salvó de perder alumnos que venían a probar. Ahora sé exactamente qué decir en cada momento. Mi tasa de conversión de primera clase a pack mensual subió de manera notable.',
  name: 'Laura V.',
  role: 'Profe en Centro de Rehabilitación',
  loc: 'Santa Fe',
  initial: 'L',
  color: 'bg-teal-500'
}, {
  quote: 'El Patologías Pro me cambió la cabeza. Nunca había dimensionado el riesgo que corría sin adaptaciones claras para mis alumnos con condiciones especiales. Ahora trabajo con una tranquilidad que antes no tenía.',
  name: 'Ana R.',
  role: 'Kinesióloga en Centro de Salud',
  loc: 'Salta',
  initial: 'A',
  color: 'bg-indigo-500'
}];
export function Testimonials() {
  return <section className="py-10 md:py-20 px-4 bg-white" data-id="element-269">
      <div className="max-w-6xl mx-auto" data-id="element-270">
        <div className="text-center mb-8 md:mb-16" data-id="element-271">
          <h2 className="font-display text-4xl md:text-5xl text-navy-900 uppercase tracking-wide mb-4" data-id="element-272">
            Lo que dicen los profes que ya lo usan
          </h2>
          <p className="text-xl text-navy-600 font-medium" data-id="element-273">
            +500 profes y kinesiólogos de todo el país ya tienen su FUERZA MAYOR
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-274">
          {testimonials.map((t, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx % 3 * 0.1
        }} className="bg-navy-50 p-8 rounded-2xl border border-navy-100 flex flex-col" data-id="element-275">
              <div className="flex gap-1 mb-6" data-id="element-276">
                {[1, 2, 3, 4, 5].map(i => <Star key={i} size={18} className="text-gold fill-gold" data-id="element-277" />)}
              </div>
              <p className="text-navy-800 italic mb-8 flex-grow text-lg leading-relaxed" data-id="element-278">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-4 border-t border-navy-200 pt-6" data-id="element-279">
                <div className={`w-12 h-12 rounded-full ${t.color} text-white flex items-center justify-center font-bold text-xl shrink-0`} data-id="element-280">
                  {t.initial}
                </div>
                <div data-id="element-281">
                  <p className="font-bold text-navy-900" data-id="element-282">{t.name}</p>
                  <p className="text-sm text-navy-600" data-id="element-283">{t.role}</p>
                  <p className="text-xs text-navy-400 mt-0.5" data-id="element-284">{t.loc}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}